<template>
  <VDialogBox
    ref="dialogLoginRef"
    v-model="visible"
    :class="`m-dialog-login${isWeb ? '_pc' : ''}`"
  >
    <template v-if="!isWeb" #close-btn>
      <button class="close-btn" @click="close" v-if="showClose">
        <InlineSvg class="icon" icon="~public/images/inline/close.svg" />
      </button>
      <div v-else></div>
    </template>

    <Login
      v-if="visible"
      type="modal"
      :is-pc="isWeb"
      :no-change-region="noChangeRegion"
      :check-kyc="checkKyc"
      @success="onLoginSuccess"
      @close="close"
    />
  </VDialogBox>
</template>

<script>
import { ref, unref, computed, onMounted } from '@vue/composition-api'
import { useEventBus, useWindowSize } from '@vueuse/core'
import VDialogBox from 'fe-vui/dialogBox'
import modalHelper from '@ms/utils/scroll-fixed'
import { useUserStore } from '@ms/stores/user'
import { trackUserId } from '@ms/utils/track.js'
import chatBall from '@ms/components/chat/ball.js'
import { Login } from '@ms/ui/login'
import { useDomThemeSwitcher } from 'composables/useDomThemeSwitcher.js'

export default {
  components: {
    VDialogBox,
    Login
  },
  setup() {
    const visible = ref(false)
    const onClose = ref(null)
    const { width } = useWindowSize()
    const isWeb = computed(() => unref(width) >= 750)

    const close = (type = true) => {
      modalHelper.beforeClose()
      visible.value = false
      onClose.value && onClose.value(type)
      chatBall.levelDown()
    }

    useEventBus('LOGIN_SUCCESS').on(() => {
      useUserStore().getBalance()
      close(false)
      trackUserId()
    })

    const dialogLoginRef = ref(null)
    onMounted(() => {
      useDomThemeSwitcher().syncTheme(dialogLoginRef.value?.$el)
    })

    return {
      visible,
      onClose,
      isWeb,
      dialogLoginRef,
      close
    }
  },
  data() {
    return {
      showClose: true,
      noChangeRegion: false,
      checkKyc: false,
      onSuccess: null
    }
  },
  methods: {
    update(options = {}) {
      this.showClose = options.showClose
      this.noChangeRegion = options.noChangeRegion
      this.checkKyc = options.checkKyc
      this.onSuccess = options.onSuccess
      this.onClose = options.onClose
    },
    open() {
      this.visible = true
      chatBall.levelUp()
    },
    onLoginSuccess() {
      if (this.onSuccess) {
        this.onSuccess()
      }
      modalHelper.beforeClose()
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.m-dialog-login {
  > .dialog {
    width: 100%;
    height: 100%;
    background: #000;

    .close-btn {
      position: absolute;
      z-index: 1;
      top: 10px;
      right: 20px;

      .icon {
        width: 24px;
        height: 24px;
        color: white;
      }
    }

    .dialog--main {
      overflow: auto;
      height: 100%;
    }
  }
}

.m-dialog-login_pc {
  > .dialog {
    width: 450px;
    background: #fff;
  }
}

[data-mode="light"].m-dialog-login {
  > .dialog {
    border-radius: 0;
    background: #f8f8f8;

    .close-btn {
      .icon {
        color: #000;
      }
    }
  }
}
</style>
